export function withCommas(value: string | number): string {
    const nStr = value + '';
    let x = nStr.split('.');
    let x1 = x[0];
    let x2 = x.length > 1 ? '.' + x[1] : '';
    const rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
}

export function withAnnotate(inValue, inMaxPlaces, inForcePlaces, inAbbr) {
    let rounded;
    switch (inAbbr) {
        case 'T':
            rounded = inValue / 1e12;
            break;
        case 'B':
            rounded = inValue / 1e9;
            break;
        case 'M':
            rounded = inValue / 1e6;
            break;
        case 'K':
            rounded = inValue / 1e3;
            break;
        case '':
            rounded = inValue;
            break;
    }
    if (inMaxPlaces !== false) {
        let test = new RegExp('\\.\\d{' + (inMaxPlaces + 1) + ',}$');
        if (test.test((rounded.toString()))) {
            rounded = rounded.toFixed(inMaxPlaces);
        }
    }
    if (inForcePlaces !== false) {
        rounded = Number(rounded).toFixed(inForcePlaces);
    }
    return withCommas(rounded + (inAbbr || ''));
}
